<script lang="ts" setup></script>
<template>
  <div class="d-inline-block">
    <div class="d-inline-block ms-1 clock-lines">
      <div class="border-top border-danger w-100" />
      <div class="border-top border-danger w-100" />
      <div class="border-top border-danger w-100" />
    </div>
    <i class="bi bi-clock-fill text-danger fs-6 align-middle" />
  </div>
</template>
<style lang="scss" scoped>
.clock-lines {
  width: 8px;
  margin-right: 2px;
  vertical-align: middle;
  text-align: right;
  div {
    margin: 2px 0;
    border-width: 0.1rem !important;
    margin-left: auto;
    &:nth-child(2) {
      width: 80% !important;
    }
  }
}
</style>
